import { render, staticRenderFns } from "./bfmindmap2.vue?vue&type=template&id=6c801ea2&scoped=true&"
import script from "./bfmindmap2.vue?vue&type=script&lang=js&"
export * from "./bfmindmap2.vue?vue&type=script&lang=js&"
import style0 from "./bfmindmap2.vue?vue&type=style&index=0&id=6c801ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c801ea2",
  null
  
)

export default component.exports